export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
          🍉 关于我们
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mb-10">
          了解51今日吃瓜的背后故事
        </p>

        <div className="bg-background-100 border border-background-200/70 rounded-2xl p-8 md:p-10 text-left">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            <strong className="text-foreground-900">51今日吃瓜</strong>成立于2023年，是国内领先的吃瓜内容聚合平台。我们致力于为全网瓜友提供最新、最全、最热的吃瓜短视频与直播回放合集，覆盖娱乐圈动态、网红八卦、社会热点、综艺节目、吃瓜大赛等多元内容。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            我们的编辑团队7×24小时追踪全网热点，确保每一条吃瓜内容都经过精心筛选和整理，让你不错过任何一个精彩的瓜。目前平台已累计收录超过<strong className="text-primary-600">10万条</strong>吃瓜视频，服务超过<strong className="text-primary-600">百万瓜友</strong>。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            吃瓜是一种生活态度，也是一种社交方式。在51今日吃瓜，你不仅能吃到最新鲜的瓜，还能与全国瓜友一起交流讨论，分享你的独家视角和犀利点评。
          </p>
        </div>
      </div>
    </section>
  );
}